import script from "./IEventsListRow.vue?vue&type=script&setup=true&lang=js"
export * from "./IEventsListRow.vue?vue&type=script&setup=true&lang=js"

import "./IEventsListRow.vue?vue&type=style&index=0&id=4c908b2c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c908b2c"]])

export default __exports__